import { createApiClient } from 'Network/ApiClient';

export const DrugAllowedwithActivityAxiosInstance = createApiClient('DrugsNotAllowedActivity/');


